import { render, staticRenderFns } from "./ConfigurationForm122.vue?vue&type=template&id=5a958d47&scoped=true&lang=pug&"
import script from "./ConfigurationForm122.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm122.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm122.vue?vue&type=style&index=0&id=5a958d47&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a958d47",
  null
  
)

export default component.exports